export const integerOnly = {
  bind(el, binding, vnode) {
    const allowDecimal = binding.value && binding.value.allowDecimal;
    const currencyFormat = binding.value && binding.value.currencyFormat;
    const normalInput = binding.value && binding.value.normalInput;
    const decimalLimit = binding.value && binding.value.decimalLimit;
    if (normalInput) {
      return
    }
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      let newValue = '';

      if (allowDecimal) {
        const firstDecimalIndex = inputValue.indexOf(".");
        newValue = inputValue.replace(/\./g, (match, offset) => {
          return offset === firstDecimalIndex ? match : '';
        });

        if (decimalLimit) {
          // Limit to two digits after the decimal point
          const decimalSplit = newValue.split('.');
          if (decimalSplit.length > 1) {
            const integerPart = decimalSplit[0];
            let decimalPart = decimalSplit[1];
            // Limit to decimalLimit digits after the decimal point
            decimalPart = decimalPart.slice(0, decimalLimit);
            newValue = integerPart + '.' + decimalPart;
          }
        }

        // Remove any non-digit and non-decimal point characters
        newValue = newValue.replace(/[^\d.]+/g, '');
      } else {
        // Remove any non-digit characters
        newValue = inputValue.replace(/\D/g, '');
      }

      if (currencyFormat && newValue) {
        // Format the numeric value as US currency
        const string = "" + newValue
        const lastChar = string.charAt(string.length - 1)
        if (newValue !== ".") {
          let afterDecimal = newValue.split('.')[1]
          if (afterDecimal) {
            if (afterDecimal[afterDecimal.length -1] != '0') {
              newValue = parseFloat(newValue).toLocaleString("en-US", {
                maximumFractionDigits: 6
              })
            }
          }
          else {
            newValue = parseFloat(newValue).toLocaleString("en-US", {
              maximumFractionDigits: 6
            })
          }

          if (lastChar === ".") {
            newValue += lastChar
          }
        }
      }
      // Update the input value with the formatted currency value
      event.target.value = newValue;
      // Emit an event with the sanitized numeric value
      // vnode.componentInstance.$emit('input', newValue);
    });
  }
}
